export type ThemePreference = 'dark' | 'light';

export const THEME_PREFERENCE_STORAGE_KEY = 'ui-theme-preference';
export const THEME_PREFERENCE_EVENT = 'theme-preference-changed';

const resolveThemeUserId = (userId?: string | number | null) => {
  if (userId !== undefined && userId !== null && userId !== '') return String(userId);
  if (typeof window === 'undefined') return '';
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw) return '';
    const parsed = JSON.parse(raw);
    return String(parsed?.id || '');
  } catch {
    return '';
  }
};

export const getThemePreferenceStorageKey = (userId?: string | number | null) => {
  const resolvedUserId = resolveThemeUserId(userId);
  return resolvedUserId ? `${THEME_PREFERENCE_STORAGE_KEY}:${resolvedUserId}` : THEME_PREFERENCE_STORAGE_KEY;
};

export const getUserThemePreferenceSettingKey = (userId: string | number) => `user_${userId}_theme_preference`;

export const getStoredThemePreference = (userId?: string | number | null): ThemePreference => {
  if (typeof window === 'undefined') return 'dark';
  const value = localStorage.getItem(getThemePreferenceStorageKey(userId)) || localStorage.getItem(THEME_PREFERENCE_STORAGE_KEY);
  return value === 'light' ? 'light' : 'dark';
};

export const setStoredThemePreference = (value: ThemePreference, userId?: string | number | null) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getThemePreferenceStorageKey(userId), value);
  window.dispatchEvent(new CustomEvent(THEME_PREFERENCE_EVENT, { detail: { value, userId: resolveThemeUserId(userId) } }));
};

export const getThemeWrapperClass = (value: ThemePreference) => {
  return value === 'light' ? 'theme-light' : 'theme-dark-orange';
};
